import axios from "axios";

export const getBackendApiBaseUrl = () => {
    //const hostname = window.location.hostname;

    //return 'http://dev-api-afp.agrobank.uz/test_be'; //#AGROBANK for agro server
    return 'https://afp.kmbat.uz/afp'; //# DEMO for local dev
    //return '/afp';
};

export default Object.assign( axios.create({
    baseURL: getBackendApiBaseUrl()
}), {
    isCancel: axios.isCancel,
    CancelToken: axios.CancelToken
});

